import React, { Component } from "react"
import { Link } from "gatsby"
import styled from "@emotion/styled"
import theme from "../styles/theme"

import Logo from "../images/logo.svg"

const Container = styled.div`
  width: 100%;
  padding: 32px;
`

const Inner = styled.div`
  max-width: ${theme.maxwidth.default};
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  display: flex;
  a {
    color: ${theme.color.ink};
    text-decoration: none;
  }
  * + * {
    margin-left: 8px;
  }
`

const LogoImg = styled.img`
  height: 28px;
`
const LogoContainer = styled.div`
  margin-right: auto;
  a {
    display: flex;
    align-items: center;
  }
`
const Content = styled.div`
  margin: 0;
  a {
    text-decoration: underline;
    margin-right: 16px;
  }
`

export default class Nav extends Component {
  render() {
    return (
      <Container>
        <Inner>
          <LogoContainer>
            <Link to="/">
              <LogoImg src={Logo} alt="Stack Logo"></LogoImg>
            </Link>
          </LogoContainer>
          <Content>
            <Link to="/terms-and-conditions">Terms &amp; Conditions</Link>
            <Link to="/privacy-policy">Privacy Policy</Link> ©{" "}
            {new Date().getFullYear()}, StackGlobal.io
          </Content>
        </Inner>
      </Container>
    )
  }
}
